import React, { useState } from 'react'
import { LayoutCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/layout/LayoutCP'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { ModalQAQCExecuteCP } from 'modules/reports/screens/screen-charts/content/qaqc/ModalQAQCExecuteCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import styled from 'styled-components'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'
import { ScreenContentQAQCHistoryTable } from 'modules/reports/screens/screen-qaqc/content/ScreenContentQAQCHistoryTable'
import { CollapseCP } from 'submodules/nerit-framework-ui/common/components/collapse/CollapseCP'
import { CardCP } from 'submodules/nerit-framework-ui/common/components/card/CardCP'

interface ICPProps {
    title: string
    type: QAQCExecutionTypeEnum
    infoTitle: string
    infoContent: JSX.Element
}

/**
 * Casca de listagem QAQC reutilizada pelos conteúdos do submenu.
 */
export function ScreenContentQAQCHistoryBase(props: ICPProps): JSX.Element {

    const [reloadTable, setReloadTable] = useState<number>(TableUtils.getReloadNumber())
    const [isExecuteModalVisible, setIsExecuteModalVisible] = useState<boolean>(false)

    function onExecuteSuccess(): void {
        setReloadTable(TableUtils.getReloadNumber())
        setIsExecuteModalVisible(false)
    }

    return (
        <>
            <LayoutCP
                overflowVertical={true}
                header={
                    <HeaderCP title={props.title}>
                        <ButtonCP onClick={() => setIsExecuteModalVisible(true)}>
                            <TextCP text={'Nova Execução'} strong={true} />
                        </ButtonCP>
                    </HeaderCP>
                }
                content={
                    <ContentWrapperSCP>
                        <InfoCardWrapperSCP>
                            <CardCP margin={'20px'} innerSpacing={'none'} bordered={true}>
                                <CollapseCP
                                    bordered={false}
                                    defaultPanelKeys={[]}
                                    panels={[
                                        {
                                            key: 'qaqc-info',
                                            title: props.infoTitle,
                                            content: (
                                                <InfoContentSCP>
                                                    {props.infoContent}
                                                </InfoContentSCP>
                                            ),
                                        },
                                    ]}
                                />
                            </CardCP>
                        </InfoCardWrapperSCP>
                        <ScreenContentQAQCHistoryTable
                            type={props.type}
                            reloadTable={reloadTable}
                            onReload={() => setReloadTable(TableUtils.getReloadNumber())}
                        />
                    </ContentWrapperSCP>
                }
            />
            <ModalQAQCExecuteCP
                type={props.type}
                visible={isExecuteModalVisible}
                onSave={onExecuteSuccess}
                onCancel={() => setIsExecuteModalVisible(false)}
            />
        </>
    )
}

const ContentWrapperSCP = styled.div`
    padding: 20px;
`

const InfoCardWrapperSCP = styled.div`
    margin-bottom: 4px;
`

const InfoContentSCP = styled.div`
    p {
        margin-bottom: 12px;
        line-height: 1.6;
    }

    ul,
    ol {
        margin: 0 0 12px 20px;
    }

    li {
        margin-bottom: 10px;
        line-height: 1.6;
    }
`
